/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const components = {
  chip: {
    background: {
      '@': '#f8f8fa0a',
      disabled: '#f8f8fa14',
      hover: '#f8f8fa14',
      selected: '#f8f8fa1f',
    },
    border: {
      '@': '#f8f8fa29',
      focus: '#9966ab',
    },
    borderWidth: 1,
    deleteIcon: {
      colour: {
        hover: '#f8f8fa',
      },
    },
    filled: {
      background: {
        '@': '#484885',
        hover: '#484885',
        selected: '#484885',
      },
      error: {
        background: {
          '@': '#ce1c25',
          hover: '#ce1c25',
          selected: '#ce1c25',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      info: {
        background: {
          '@': '#0158f9',
          hover: '#0158f9',
          selected: '#0158f9',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      label: '#f8f8fa',
      primary: {
        background: {
          '@': '#793690',
          hover: '#793690',
          selected: '#793690',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      success: {
        background: {
          '@': '#1b7936',
          hover: '#1b7936',
          selected: '#1b7936',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      warning: {
        background: {
          '@': '#bd4f00',
          hover: '#bd4f00',
          selected: '#bd4f00',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
    },
    icon: {
      colour: '#afafc9',
    },
    label: {
      '@': '#f8f8fa',
      disabled: '#ffffff52',
    },
    outlined: {
      background: {
        hover: '#f8f8fa14',
        selected: '#f8f8fa',
      },
      error: {
        background: {
          '@': '#080101',
          hover: '#ce1c251a',
          selected: '#ce1c25',
        },
        border: {
          '@': '#db575d',
          selected: '#ce1c25',
        },
        label: {
          '@': '#db575d',
          selected: '#f8f8fa',
        },
      },
      info: {
        background: {
          '@': '#00030a',
          hover: '#0158f91a',
          selected: '#0158f9',
        },
        border: {
          '@': '#3e80fa',
          selected: '#0158f9',
        },
        label: {
          '@': '#8fb6fc',
          selected: '#f8f8fa',
        },
      },
      label: '#f8f8fa',
      primary: {
        background: {
          '@': '#050206',
          hover: '#7936901a',
          selected: '#793690',
        },
        border: {
          '@': '#9966ab',
          selected: '#793690',
        },
        label: {
          '@': '#c4a7ce',
          selected: '#f8f8fa',
        },
      },
      success: {
        background: {
          '@': '#010502',
          hover: '#1b79361a',
          selected: '#1b7936',
        },
        border: {
          '@': '#529966',
          selected: '#1b7936',
        },
        label: {
          '@': '#529966',
          selected: '#f8f8fa',
        },
      },
      warning: {
        background: {
          '@': '#070300',
          hover: '#bd4f001a',
          selected: '#bd4f00',
        },
        border: {
          '@': '#cd793d',
          selected: '#bd4f00',
        },
        label: {
          '@': '#cd793d',
          selected: '#f8f8fa',
        },
      },
    },
    radius: 1000000000,
    selected: {
      background: '#f8f8fa',
      label: '#0e0d24',
    },
    size: {
      large: {
        avatarPaddingLeft: 4,
        avatarSize: 32,
        gap: -16,
        height: 40,
        iconPaddingX: 12,
        paddingX: 12,
      },
      medium: {
        avatarPaddingLeft: 4,
        avatarSize: 24,
        gap: -12,
        height: 32,
        iconPaddingX: 8,
        paddingX: 8,
      },
      small: {
        avatarPaddingLeft: 4,
        avatarSize: 18,
        gap: -12,
        height: 24,
        iconPaddingX: 8,
        paddingX: 8,
      },
    },
    soft: {
      background: {
        '@': '#f8f8fa0a',
        hover: '#f8f8fa14',
        selected: '#f8f8fa',
      },
      error: {
        background: {
          '@': '#42090c',
          hover: '#ce1c251a',
          selected: '#ce1c25',
        },
        label: {
          '@': '#f9e3e4',
          selected: '#f8f8fa',
        },
      },
      info: {
        background: {
          '@': '#001c50',
          hover: '#0158f91a',
          selected: '#0158f9',
        },
        label: {
          '@': '#e0ebfe',
          selected: '#f8f8fa',
        },
      },
      label: '#f8f8fa',
      primary: {
        background: {
          '@': '#27112e',
          hover: '#7936901a',
          selected: '#793690',
        },
        label: {
          '@': '#efe7f2',
          selected: '#f8f8fa',
        },
      },
      success: {
        background: {
          '@': '#092711',
          hover: '#1b79361a',
          selected: '#1b7936',
        },
        label: {
          '@': '#e3efe7',
          selected: '#f8f8fa',
        },
      },
      warning: {
        background: {
          '@': '#3d1900',
          hover: '#bd4f001a',
          selected: '#bd4f00',
        },
        label: {
          '@': '#f7eae0',
          selected: '#f8f8fa',
        },
      },
    },
  },
} as const;
